export default {
  metrics: {
    go_lives: 'Totale lanci',
    avg_quality_score: 'Punteggio qualità medio',
    managers: {
      title: 'Manager onboarding',
      fields: {
        name: 'Nome manager',
        go_lives: 'Lanci',
        avg_quality_score: 'Punteggio qualità medio',
      },
    },
  },
  details: {
    name: 'Ristorante',
    owner: 'Nome titolare',
    owner_phone: 'Telefono titolare',
    owner_email: 'Email titolare',
    live_from: 'Data di lancio',
    onboarding_manager: 'Manager onboarding',
    sales_manager: 'Manager commerciale',
    onboarding_quality_score: 'Punteggio qualità',
    export_csv: 'Esporta CSV',
  },
};
